import { useAtomValue } from 'jotai';

import { initialSyncCompleteAtom, initialSyncResolvedAtom } from '@/state';

export interface SyncStatus {
  initialSyncComplete: boolean;
  initialSyncResolved: boolean;
}

export const useSyncStatus = (): SyncStatus => {
  const initialSyncComplete = useAtomValue(initialSyncCompleteAtom);
  const initialSyncResolved = useAtomValue(initialSyncResolvedAtom);
  return { initialSyncComplete, initialSyncResolved };
};
